<div class="backgroundContainer">
    <img src="assets/images/Osterburg_Groothusen.jpg" alt="Background Image" />
  </div>
